const releasesNL = {
    "view": {
        "table": {
            "title": "Uw release lijst",
            "column": {
                "name": "Naam",
                "artist": "Artiest",
                "catalogue_number": "Cat. Nr.",
                "release_date": "Releasedatum",
                "status": "Status",
                "store_urls": "Winkel URL's",
                "qc": "QC",
                "pre_scan": "Voorab-Scan",
                "alert": "Waarschuwing",
                "flagged": "Gevlagd",
                "action": "Actie"
            },
            "label": {
                "status_ready": "Klaar",
                "status_approval": "Ingediend in wachtrij",
                "status_takedown_request": "Verwijderingsverzoek",
                "status_taken_down": "Verwijderd",
                "status_distributed": "Gedistrubueerd",
                "status_locked": "In uitvoering - Vergrendeld",
                "status_delivering": "Bezig met leveren",
                "status_unlocked": "Gelieve te bewerken",
                "status_offline": "Offline",
                "status_re_delivery-delivery": "Herlevering",
                "status_re_delivery-editing": "Herlevering Bewerken",
                "status_unknown": "Onbekende Status"
            },
            "button": {
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "dropdown": {
                "item": {
                    "action": "Actie",
                    "distribute": "Distribueer",
                    "viewRelease": "Bekijk Release",
                    "editReleaseMetadata": "Bewerk Release Metadata",
                    "editTracks": "Bewerk Tracks",
                    "takedown": "Verwijderen",
                    "submitEditing": "Bewerken Indienen",
                    "deliveredList": "Geleverde Lijst",
                    "copyEanUpc": "Kopieer EAN/UPC"
                },
                "message": {
                    "submitInformationTooltip": "U heeft uw volledige informatie nog niet verstrekt, daarom kunt u de releases niet distribueren. Om dit te doen, dien alstublieft uw informatie in.",
                    "submitMetadataTooltip": "Gelieve de metadata voor alle tracks in te dienen om de release te distribueren.",
                    "submitEditingMetadataTooltip": "Gelieve de metadata voor alle tracks in te dienen om de bewerkingen in te dienen.",
                    "submitEditingTokenRequiredTooltip": "Minimaal 1 token is vereist om de bewerking voor herlevering in te dienen. <2>Bestel tokens</2>.",
                    "blacklistedArtistTooltip": "Deze release kan niet worden gedistribueerd omdat het een of meer tracks bevat van een blacklisted artiest. Neem contact op met ons ondersteuningsteam voor meer informatie.",
                    "distributionDisabledPreScanInProgress": "Gelieve te wachten tot de pre scan is voltooid voordat u de release kunt distribueren.",
                    "distributionDisabledPreScanNotDone": "Gelieve de pre scan eerst uit te voeren om de release te distribueren.",
                    "distributionDisabledPreScanDeclarationNotSubmitted": "Gelieve de pre-scan verklaring eerst in te dienen om de release te distribueren.",
                },
                "modal": {
                    "editMetadata": {
                        "header": "Weet u zeker dat u de metadata wilt bewerken?",
                        "description": {
                            "point1": "<strong>Dit zal uw metadata wijzigen en kan de release beïnvloeden.</strong>",
                            "point2": "Ga alleen verder als u volledig zeker bent.",
                            "point3": "<strong>GELIEVE NIET</strong> metadata te bewerken alleen voor testen en verkennen."
                        },
                        "button": {
                            "cancel": "Annuleren",
                            "confirm": "Ik begrijp het"
                        }
                    },
                    "distribute": {
                        "header": "Weet u zeker dat alle ingevoerde informatie geldig is en deze release volledig vertegenwoordigt?",
                        "description": {
                            "point1": "Na deze actie zal uw release worden gecontroleerd en als de informatie correct is, zal het worden gedistribueerd op de officiële en exclusieve distributiedata.",
                            "point2": "Door dit formulier te bevestigen en te accepteren, accepteert en voldoet u volledig aan de <1>Distributievoorwaarden</1>, <3>Gebruiksvoorwaarden</3> en <5>Privacybeleid</5>.",
                            "point3": "Door dit formulier te bevestigen en te accepteren, bevestigt u onbetwistbaar dat de ingediende inhoudsrelease met bijbehorende middelen, audiobestanden en metadata, ofwel exclusief aan u toebehoort of volledig is gelicentieerd aan uw label.",
                            "point4": "Hierbij accepteert u volledig dat u als enige verantwoordelijk bent voor enige misleidende informatie, ongeoorloofd gebruik, illegale activiteit of enige vorm van geschil.",
                            "flaggedTracksTerms": {
                                "header": "Voorwaarden Gevlagde Tracks",
                                "point1": "Let op: <strong>'{{releaseName}}'</strong> bevat een of meer gevlagde tracks. Er geldt een vergoeding van <strong>15 €</strong> per gevlagde track om de release naar <strong>Spotify</strong> te leveren. Aangezien u ervoor heeft gekozen deze vergoeding op dit moment niet te betalen, zal de release niet naar Spotify worden geleverd. Door dit formulier te bevestigen en te accepteren, erkent en accepteert u deze voorwaarden.",
                                "point2": "In de toekomst, als u ervoor kiest om de release naar <strong>Spotify</strong> te laten leveren, kunt u naar de Gevlagde sectie in de Releases-tabel gaan en de betalingsinstructies volgen."
                            },
                            "artificialStreamingDeclaration": {
                                "header": "Verklaring Kunstmatige Streaming",
                                "point1": "<strong>1.</strong> Ik begrijp volledig en ga ermee akkoord om niet deel te nemen aan enige vorm van kunstmatige streaming, inclusief het gebruik van bots, streaming farms, of enige methode die DSP-metrics manipuleert.",
                                "point2": "<strong>2.</strong> Ik zal niet betalen of betaling aanbieden voor playlistplaatsingen, noch zal ik samenwerken met een derde partij die gegarandeerde plaatsingen belooft — ik begrijp dat dit als fraude en een zwendel wordt beschouwd.",
                                "point3": "<strong>3.</strong> Ik erken dat dergelijke acties kunnen leiden tot onmiddellijke beëindiging, verlies van royalty's, juridische claims, contractuele boetes en kosten, en rapportage aan DSP's en autoriteiten.",
                                "point4": "<strong>4.</strong> Ik garandeer ook om alle artiesten of klanten met wie ik werk over deze regels te informeren en ervoor te zorgen dat zij zich eraan houden.",
                                "point5": "<strong>5.</strong> Ik begrijp dat als ik me bezighoud met kunstmatige streaming, mijn KYC-gegevens, inclusief mijn volledige naam, adres, ID-kaart en andere persoonlijke informatie, kunnen worden gedeeld met de juridische afdelingen van de DSP's, zoals die van Spotify, Apple Music en anderen.",
                                "point6": "<strong>6.</strong> Ik accepteer volledige juridische verantwoordelijkheid voor eventuele overtredingen.",
                                "acknowledgment": "Hierbij erken en ga ik akkoord met de bovenstaande voorwaarden voor kunstmatige streaming, en accepteer ik volledige juridische verantwoordelijkheid voor eventuele overtredingen."
                            }
                        },
                        "button": {
                            "cancel": "Annuleren",
                            "confirm": "Bevestigen en Accepteren"
                        }
                    },
                    "takedown": {
                        "header": "Weet u zeker dat u deze release uit alle winkels wilt verwijderen?",
                        "description": {
                            "point1": "Deze actie is onomkeerbaar.",
                            "point2": "Door deze release te verwijderen, voldoet u aan de <1>Distributievoorwaarden</1>, <3>Gebruiksvoorwaarden</3> en <5>Privacybeleid</5>."
                        },
                        "button": {
                            "cancel": "Annuleren",
                            "confirm": "Bevestigen en Accepteren"
                        }
                    },
                    "finishEditing": {
                        "header": "Weet u zeker dat alle ingevoerde informatie geldig is en deze release volledig vertegenwoordigt?",
                        "description": {
                            "point1": "Na deze actie zal uw release worden gecontroleerd en als de informatie correct is, zal het opnieuw worden gedistribueerd naar de DSP-partners. <strong>LET OP, alleen METADATA zal naar DSP's worden gestuurd, inhoud zoals BEELD en AUDIO-bestanden kunnen op deze manier niet worden bijgewerkt.</strong>",
                            "point2": "Door dit formulier te bevestigen en te accepteren, accepteert en voldoet u volledig aan de <1>Gebruiksvoorwaarden</1> en de voorwaarden van onze Exclusieve Distributieovereenkomst.",
                            "point3": "Door dit formulier te bevestigen en te accepteren, accepteert en voldoet u volledig aan het <1>Privacybeleid</1>.",
                            "point4": "Door dit formulier te bevestigen en te accepteren, bevestigt u onbetwistbaar dat de ingediende inhoudsrelease met bijbehorende middelen, audiobestanden en metadata, ofwel exclusief aan u toebehoort of volledig is gelicentieerd aan uw label.",
                            "point5": "Hierbij accepteert u volledig dat u als enige verantwoordelijk bent voor enige misleidende informatie, ongeoorloofd gebruik, illegale activiteit of enige vorm van geschil."
                        },
                        "button": {
                            "cancel": "Annuleren",
                            "confirm": "Bevestigen en Accepteren"
                        }
                    }
                }
            },
            "message": {
                "success": "Release bijgewerkt!",
                "declaration_success": "Verklaring ingediend voor administratieve beoordeling.",
                "declaration_error": "Er is iets misgegaan bij het indienen van de verklaring, probeer het later opnieuw.",
                "pre_scan_declaration_success": "Pre Scan verklaring ingediend met succes.",
                "pre_scan_declaration_error": "Er is iets misgegaan bij het indienen van de verklaring van de pre-scan, probeer het later opnieuw.",
                "pre_scan_success": "Release succesvol ingediend voor scan.",
                "pre_scan_error": "Er is iets misgegaan bij het scannen van de release, probeer het later opnieuw.",
                "linkCopied": "Link gekopieerd naar klembord!"
            }
        },
        "message": {
            "trackDistributionAllowanceSpent": "U heeft uw trackdistributietoelage verbruikt. Om meer tracks te uploaden, upgrade alstublieft uw account of neem contact op met ons ondersteuningsteam.",
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om deze functie te gebruiken.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie.",
            "subscriptionUpgradeReleaseTransfer": "Uw huidige abonnementsplan ondersteunt de release-overdrachtsfunctie niet. Als u een grotere backcatalogus overdraagt of meer platenlabelcatalogi naar Music Link wilt overbrengen met slechts een paar klikken, upgrade dan alstublieft uw abonnementsplan.",
            "noAccessReleaseTransfer": "Momenteel heeft u geen toestemming om de release-overdrachtsfunctie te gebruiken. Als u een grotere backcatalogus overdraagt of meer platenlabelcatalogi naar Music Link wilt overbrengen met slechts een paar klikken, aarzel dan niet om contact op te nemen met ons ondersteuningsteam.",
            "accountBlacklisted": "Uw account is na een controle als zwarte lijst gemarkeerd, omdat we hebben ontdekt dat de informatie die aan uw account is gekoppeld aan een van de internationale zwarte lijst gebruikers in ons systeem is gekoppeld. Daarom hebben we de distributiefunctie voor uw account uitgeschakeld.",
        }
    },
    "add": {
        "title": "Nieuwe Release Toevoegen",
        "form": {
            "label": {
                "required": "Vereist",
                "name": "Releasenaam",
                "version": "Releaseversie",
                "subuser": "Subgebruiker",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jaar",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jaar",
                "genre": "Genre",
                "subgenre": "Subgenre",
                "catalog_number": "Catalogusnummer",
                "artwork": "Omslag",
                "artwork_alt": "Uw omslag",
                "new_release": "Is dit een nieuwe release?",
                "original_release_date": "Oorspronkelijke releasedatum",
                "official_release_date": "Officiële releasedatum",
                "backcatalog": "Backcatalogus",
                "assisted_dates": "Geassisteerde Data",
                "exclusive_store_release_date": "Exclusieve winkel releasedatum",
                "additional_metadata": "Aanvullende Metadata",
                "release_description": "Releasebeschrijving",
                "release_language": "Releasenaam Taal",
                "auto_detect_language": "Automatisch detecteren (Taal)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatisch genereren (ean)",
                "territories": "Territoria",
                "countries": "Landen",
                "youtube_declaration_header": "YOUTUBE CONTENT ID VERKLARING",
                "youtube_declaration_intro": "Om in te schrijven voor YouTube Content ID voor deze release, moet u ervoor zorgen dat u aan ALLE volgende vereisten voldoet:",
                "youtube_declaration_certify": "Ik, <strong>{{firstName}} {{lastName}}</strong>, onder straf van meineed, verklaar hierbij dat de bovenstaande informatie waar en correct is.",
                "youtube_declaration_point1": "Ik heb voldoende rechten op het materiaal.",
                "youtube_declaration_point2": "Alle referentie-inhoud is voldoende onderscheidend.",
                "youtube_declaration_point3": "Ik heb individuele referenties voor elk stuk intellectueel eigendom.",
                "youtube_declaration_point4": "De geleverde inhoud is <strong>niet</strong> een van de volgende: publiek domein, niet-exclusief gelicentieerde inhoud, clips van andere bronnen gebruikt onder fair use-principes, videogamebeelden (door andere dan de uitgever van het spel), karaoke-opnamen, remaster zonder toestemming, sound-alike opnamen, gedubde inhoud, versnellen/vertragen, geluidseffecten, soundbeds, continue DJ-mixen, mashups, aftellijsten of andere verboden of niet in aanmerking komende inhoud genoemd in de YouTube's Content ID Richtlijnen hieronder.",
                "youtube_declaration_account": "Ik begrijp dat mijn account kan worden gedeactiveerd en beëindigd in geval van overtredingen. Bovendien begrijp ik volledig dat ik aansprakelijk kan zijn voor eventuele kosten, schade, juridische kosten of andere kosten die kunnen oplopen.",
                "youtube_declaration_guidelines": "Volgens <1><strong>YouTube's Content ID Richtlijnen</strong></1> is de inhoud die via deze release wordt ingediend volledig in aanmerking voor YouTube Content ID.",
                "youtube_content_id_eligible": "Ik bevestig dat mijn inhoud in aanmerking komt voor <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mijn inhoud komt niet in aanmerking voor <strong>Youtube Content ID</strong>",
                "immersive_audio": "Deze Release heeft Immersive Audio"
            },
            "placeholder": {
                "version": "Laat leeg als u het niet zeker weet of als dit een reguliere release is",
                "select_date": "Selecteer datum...",
                "copyright": "Meestal uw labelnaam",
                "copyright_publisher": "Meestal uw labelnaam",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "label": "Selecteer Label...",
                "subuser": "Selecteer Subgebruiker...",
                "genre": "Selecteer Genre...",
                "subgenre": "Selecteer Subgenre...",
                "ean": "Laat leeg als u het niet zeker weet!",
                "release_description": "Enkele woorden over uw release. Geen links en e-mailadressen alstublieft. Maximaal 600 tekens"
            },
            "help_text": {
                "name": "Gebruik alstublieft geen toevoegingen aan de releasenaam zoals LP en EP.",
                "version": "Sommige releases worden in meer dan één versie uitgebracht, als dat zo is, voer dan de versienaam in. Als uw release een originele/standaard release is, negeer dit veld dan.",
                "subuser": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen voor een van uw Subgebruikers, laat anders niet geselecteerd.",
                "label": "Opmerking: Selecteer uw Label uit de dropdown als het al in het systeem bestaat, anders maakt u uw Label door te klikken op <1>hier</1>, zodra het is aangemaakt, kunt u het selecteren uit de dropdown.",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "artwork": "Upload JPG-formaten, resolutie alleen 3000x3000 px, @ 72 dpi",
                "original_release_date": "Oorspronkelijke releasedatum voor alle winkels wereldwijd.",
                "official_release_date": "Officiële releasedatum voor alle winkels wereldwijd.",
                "release_language": "In welke taal is de releasenaam geschreven? Controleer het dubbel als u het niet zeker weet. Als deze invoer onjuist is, zullen sommige winkels zoals iTunes en Apple Music de release afwijzen.",
                "ean": "De Universele Productcode of Europees Artikelnummer voor de release. Geldige codes zijn 13 cijfers. Als u er geen heeft, zullen wij er een voor u genereren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nee",
                "no_exclusive": "Geen exclusief",
                "beatport_2weeks": "Beatport 2 weken",
                "beatport_4weeks": "Beatport 4 weken",
                "preorder_1week": "Pre-order 1 week",
                "preorder_2weeks": "Pre-order 2 weken",
                "traxsource_2weeks": "Traxsource 2 weken",
                "select": "Selecteer...",
                "worldwide": "Wereldwijd",
                "only_selected": "Alleen geselecteerde landen",
                "all_except_selected": "Alle behalve geselecteerde landen"
            },
            "message": {
                "track_name_required": "Typ alstublieft de tracknaam",
                "mix_name_required": "Typ alstublieft de mixnaam",
                "mix_name_invalid": "De mixnaam kan alleen bestaan uit alfabetische, nummer, spatie en underscore",
                "artist_required": "Selecteer alstublieft artiest",
                "artist_type_required": "Selecteer alstublieft artiesttype",
                "catalog_duplicate": "Catalogusnummer '{{number}}' is al gebruikt. Voeg een andere toe.",
                "ean_duplicate": "Dit EAN-nummer is gekoppeld aan een andere release. Voeg een andere toe.",
                "artist_added": "Nieuwe artiest toegevoegd!",
                "track_limit": "Uw huidige tracklimiet is onvoldoende. Upgrade alstublieft uw account of neem contact op met ondersteuning.",
                "select_day": "Selecteer alstublieft een dag.",
                "form_error": "Formulier kan niet worden ingediend! Vul alle velden in en controleer op fouten!",
                "ean_invalid": "De waarde is geen geldige EAN. Als u een nieuwe release invoert, laat dit veld dan leeg en wij zullen een EAN voor u genereren. Als u een backcatalogus uploadt en de EAN is niet geldig, neem dan contact met ons op.",
                "ean_length": "Het EAN-nummer moet gelijk zijn aan 13 tekens",
                "artwork_invalid": "Dit bestand is ongeldig, zorg ervoor dat de afbeelding een .jpg-extensie heeft, RGB-kleuren, 3000 X 3000 afmetingen en tot 4MB.",
                "track_invalid": "Dit bestand is ongeldig, zorg ervoor dat u uw bestand correct codeert in 16 bit, 44.1 Khz.",
                "artworkSwapTokenRequiredTooltip": "Je huidige tokenbalans is onvoldoende. Er is minimaal 1 token vereist om de cover-artwork te vervangen."
            },
            "button": {
                "reset": "Resetten",
                "save_only": "Alleen opslaan",
                "save_and_continue": "Opslaan en doorgaan"
            },
            "modal": {
                "assisted_days": {
                    "header": "Weet u zeker dat u de beste praktijken voor releasedata wilt negeren?",
                    "body": "Let op, door deze optie te selecteren, kan uw releasedatum mogelijk niet door winkels worden geaccepteerd of op de geselecteerde datum worden geïmporteerd en gepubliceerd. Bovendien vermindert u sterk de marketingmogelijkheden.",
                    "button": {
                        "cancel": "Annuleren",
                        "confirm": "Bevestigen"
                    }
                },
                "release_created": {
                    "header": "Release aangemaakt!",
                    "body": "Uw release is succesvol aangemaakt!",
                    "button": {
                        "close": "Sluiten"
                    }
                }
            }
        }
    },
    "update": {
        "title": "Release Bijwerken",
        "form": {
            "label": {
                "required": "Vereist",
                "name": "Releasenaam",
                "version": "Releaseversie",
                "subuser": "Subgebruiker",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jaar",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jaar",
                "genre": "Genre",
                "subgenre": "Subgenre",
                "catalog_number": "Catalogusnummer",
                "artwork": "Omslag",
                "artwork_alt": "Uw omslag",
                "new_release": "Is dit een nieuwe release?",
                "original_release_date": "Oorspronkelijke releasedatum",
                "official_release_date": "Officiële releasedatum",
                "backcatalog": "Backcatalogus",
                "assisted_dates": "Geassisteerde Data",
                "exclusive_store_release_date": "Exclusieve winkel releasedatum",
                "additional_metadata": "Aanvullende Metadata",
                "release_description": "Releasebeschrijving",
                "release_language": "Releasenaam Taal",
                "auto_detect_language": "Automatisch detecteren (Taal)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatisch genereren (ean)",
                "territories": "Territoria",
                "countries": "Landen",
                "youtube_declaration_header": "YOUTUBE CONTENT ID VERKLARING",
                "youtube_declaration_intro": "Om in te schrijven voor YouTube Content ID voor deze release, moet u ervoor zorgen dat u aan ALLE volgende vereisten voldoet:",
                "youtube_declaration_certify": "Ik, <strong>{{firstName}} {{lastName}}</strong>, onder straf van meineed, verklaar hierbij dat de bovenstaande informatie waar en correct is.",
                "youtube_declaration_point1": "Ik heb voldoende rechten op het materiaal.",
                "youtube_declaration_point2": "Alle referentie-inhoud is voldoende onderscheidend.",
                "youtube_declaration_point3": "Ik heb individuele referenties voor elk stuk intellectueel eigendom.",
                "youtube_declaration_point4": "De geleverde inhoud is <strong>niet</strong> een van de volgende: publiek domein, niet-exclusief gelicentieerde inhoud, clips van andere bronnen gebruikt onder fair use-principes, videogamebeelden (door andere dan de uitgever van het spel), karaoke-opnamen, remaster zonder toestemming, sound-alike opnamen, gedubde inhoud, versnellen/vertragen, geluidseffecten, soundbeds, continue DJ-mixen, mashups, aftellijsten of andere verboden of niet in aanmerking komende inhoud genoemd in de YouTube's Content ID Richtlijnen hieronder.",
                "youtube_declaration_account": "Ik begrijp dat mijn account kan worden gedeactiveerd en beëindigd in geval van overtredingen. Bovendien begrijp ik volledig dat ik aansprakelijk kan zijn voor eventuele kosten, schade, juridische kosten of andere kosten die kunnen oplopen.",
                "youtube_declaration_guidelines": "Volgens <1><strong>YouTube's Content ID Richtlijnen</strong></1> is de inhoud die via deze release wordt ingediend volledig in aanmerking voor YouTube Content ID.",
                "youtube_content_id_eligible": "Ik bevestig dat mijn inhoud in aanmerking komt voor <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mijn inhoud komt niet in aanmerking voor <strong>Youtube Content ID</strong>",
                "immersive_audio": "Deze Release heeft Immersive Audio"
            },
            "placeholder": {
                "version": "Laat leeg als u het niet zeker weet of als dit een reguliere release is",
                "select_date": "Selecteer datum...",
                "copyright": "Meestal uw labelnaam",
                "copyright_publisher": "Meestal uw labelnaam",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "label": "Selecteer Label...",
                "subuser": "Selecteer Subgebruiker...",
                "genre": "Selecteer Genre...",
                "subgenre": "Selecteer Subgenre...",
                "ean": "Laat leeg als u het niet zeker weet!",
                "release_description": "Enkele woorden over uw release. Geen links en e-mailadressen alstublieft. Maximaal 600 tekens"
            },
            "help_text": {
                "name": "Gebruik alstublieft geen toevoegingen aan de releasenaam zoals LP en EP.",
                "version": "Sommige releases worden in meer dan één versie uitgebracht, als dat zo is, voer dan de versienaam in. Als uw release een originele/standaard release is, negeer dit veld dan.",
                "subuser": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen voor een van uw Subgebruikers, laat anders niet geselecteerd.",
                "label": "Opmerking: Selecteer uw Label uit de dropdown als het al in het systeem bestaat, anders maakt u uw Label door te klikken op <1>hier</1>, zodra het is aangemaakt, kunt u het selecteren uit de dropdown.",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "artwork": "Upload JPG-formaten, resolutie alleen 3000x3000 px, @ 72 dpi",
                "original_release_date": "Oorspronkelijke releasedatum voor alle winkels wereldwijd.",
                "official_release_date": "Officiële releasedatum voor alle winkels wereldwijd.",
                "release_language": "In welke taal is de releasenaam geschreven? Controleer het dubbel als u het niet zeker weet. Als deze invoer onjuist is, zullen sommige winkels zoals iTunes en Apple Music de release afwijzen.",
                "ean": "De Universele Productcode of Europees Artikelnummer voor de release. Geldige codes zijn 13 cijfers. Als u er geen heeft, zullen wij er een voor u genereren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nee",
                "no_exclusive": "Geen exclusief",
                "beatport_2weeks": "Beatport 2 weken",
                "beatport_4weeks": "Beatport 4 weken",
                "preorder_1week": "Pre-order 1 week",
                "preorder_2weeks": "Pre-order 2 weken",
                "traxsource_2weeks": "Traxsource 2 weken",
                "select": "Selecteer...",
                "worldwide": "Wereldwijd",
                "only_selected": "Alleen geselecteerde landen",
                "all_except_selected": "Alle behalve geselecteerde landen"
            },
            "message": {
                "track_name_required": "Typ alstublieft de tracknaam",
                "mix_name_required": "Typ alstublieft de mixnaam",
                "mix_name_invalid": "De mixnaam kan alleen bestaan uit alfabetische, nummer, spatie en underscore",
                "artist_required": "Selecteer alstublieft artiest",
                "artist_type_required": "Selecteer alstublieft artiesttype",
                "catalog_duplicate": "Catalogusnummer '{{number}}' is al gebruikt. Voer een andere in.",
                "ean_duplicate": "Dit EAN-nummer is gekoppeld aan een andere release. Voeg een andere toe.",
                "artist_added": "Nieuwe Artiest is toegevoegd!",
                "track_limit": "Uw huidige tracklimiet is {{trackLimit}} track(s). Om meer tracks te uploaden, upgrade alstublieft uw account of neem contact op met ons ondersteuningsteam.",
                "select_day": "Selecteer alstublieft een dag.",
                "form_error": "Formulier kan niet worden ingediend! Vul alle velden in en controleer op fouten!",
                "ean_invalid": "De waarde is geen geldige EAN. Als u een nieuwe release invoert, laat dit veld dan leeg en wij zullen een EAN voor u genereren. Als u een backcatalogus uploadt en de EAN is niet geldig, neem dan contact met ons op.",
                "ean_length": "Het EAN-nummer moet gelijk zijn aan 13 tekens",
                "artwork_invalid": "Dit bestand is ongeldig, zorg ervoor dat de afbeelding een .jpg-extensie heeft, RGB-kleuren, 3000 X 3000 afmetingen en tot 4MB.",
                "track_invalid": "Dit bestand is ongeldig, zorg ervoor dat u uw bestand correct codeert in 16 bit, 44.1 Khz."
            },
            "button": {
                "reset": "Resetten",
                "submit_form": "Formulier Indienen",
                "save_and_continue": "Opslaan en doorgaan"
            },
            "modal": {
                "assisted_days": {
                    "header": "Weet u zeker dat u de beste praktijken voor releasedata wilt negeren?",
                    "body": "Let op, door deze optie te selecteren, kan uw releasedatum mogelijk niet door winkels worden geaccepteerd of op de geselecteerde datum worden geïmporteerd en gepubliceerd. Bovendien vermindert u sterk de marketingmogelijkheden.",
                    "button": {
                        "cancel": "Annuleren",
                        "confirm": "Bevestigen"
                    }
                },
                "release_updated": {
                    "header": "Release bijgewerkt!",
                    "body": "Uw release is succesvol bijgewerkt!",
                    "button": {
                        "close": "Sluiten"
                    }
                }
            }
        }
    },
    "transfer": {
        "title": "Release Overdragen",
        "view": {
            "title": "Release Overdragen",
            "label": {
                "searchBy": "Zoeken op",
                "upc": "UPC Nummer",
                "url": "Winkel Release URL",
                "name": "Releasenaam",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "fetchReleaseDetails": "Releasegegevens ophalen..."
            },
            "placeholder": {
                "upc": "Voer Release UPC/EAN Nummer in bijv. 5055964352523",
                "url": "Voer Release Winkel URL in bijv. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn of www.deezer.com/en/album/413370367",
                "name": "Voer Releasenaam in bijv. Warrior"
            },
            "help_text": {
                "upc": "Opmerking: Gebruik deze dropdown alleen als u een Release wilt toevoegen die al op Spotify of Deezer staat.",
                "url": "Opmerking: Gebruik deze dropdown alleen als u een Release wilt toevoegen die al op Spotify of Deezer staat.",
                "name_spotify": "Opmerking: Gebruik deze dropdown alleen als u een Release wilt toevoegen die al op Spotify staat.",
                "name_deezer": "Opmerking: Gebruik deze dropdown alleen als u een Release wilt toevoegen die al op Deezer staat."
            },
            "button": {
                "reset": "Resetten",
                "transfer": "Overdragen"
            },
            "message": {
                "release_exists": "Een release met dit UPC-nummer behoort al toe aan een andere gebruiker binnen een Music Link-platform. Importeer alleen releases die volledig aan uw bedrijf en label toebehoren. Als u denkt dat iemand uw release zonder toestemming heeft genomen, neem dan contact op met ons ondersteuningsteam."
            }
        },
        "modal": {
            "header": "Voorwaarden Release Overdracht",
            "ownership_warranty": {
                "header": "Eigendomsgarantie",
                "body": {
                    "point1": "Door deze voorwaarden te accepteren, erkent en garandeert u dat u het wettige eigendom heeft of de rechtmatige eigenaar vertegenwoordigt van alle inhoud, inclusief de release en bijbehorende nummers, die hierin worden verstrekt.",
                    "point2": "U bevestigt dat er geen auteursrechtelijk beschermd materiaal of intellectueel eigendom van een derde partij in deze release is opgenomen."
                }
            },
            "non_infringement_warranty": {
                "header": "Niet-inbreukgarantie",
                "body": {
                    "point1": "Door verder te gaan, bevestigt u uitdrukkelijk dat de inhoud die in deze release wordt ingediend, geen inbreuk maakt op de rechten van derden, inclusief maar niet beperkt tot auteursrecht, handelsmerk of andere eigendomsrechten.",
                    "point2": "U stemt ermee in geen materiaal van externe bronnen op te nemen zonder de juiste toestemming."
                }
            },
            "exclusivity_declaration": {
                "header": "Exclusiviteitsverklaring",
                "body": {
                    "point1": "Door in te stemmen met deze voorwaarden, belooft u dat de inhoud die in deze release wordt gepresenteerd, exclusief eigendom is van u of door u gemachtigde vertegenwoordiging, en dat deze niet aan een andere entiteit of platform is aangeboden of uitgebracht.",
                    "point2": "U neemt volledige verantwoordelijkheid voor enige schending van exclusiviteit en begrijpt dat een dergelijke schending kan leiden tot juridische gevolgen."
                }
            },
            "legal_consequences_awareness": {
                "header": "Bewustzijn van juridische gevolgen",
                "body": {
                    "point1": "Het is cruciaal om te begrijpen dat elke schending van de voorwaarden en garanties die in deze modal of voorwaarden worden uiteengezet, kan leiden tot ernstige juridische gevolgen.",
                    "point2": "Deze straffen kunnen onder andere aanzienlijke financiële verplichtingen, juridische bevelen en reputatieschade omvatten.",
                    "point3": "Door deze voorwaarden te accepteren, erkent u de ernst van het nakomen van de gestelde verplichtingen en erkent u dat niet-naleving kan leiden tot juridische stappen tegen u of uw organisatie."
                }
            },
            "button": {
                "cancel": "Annuleren",
                "agree": "Ik ga akkoord"
            }
        },
        "form": {
            "title": "Release Overdragen",
            "label": {
                "required": "Vereist",
                "name": "Releasenaam",
                "version": "Releaseversie",
                "subuser": "Subgebruiker",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jaar",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jaar",
                "genre": "Genre",
                "subgenre": "Subgenre",
                "catalog_number": "Catalogusnummer",
                "artwork": "Omslag",
                "artwork_alt": "Uw omslag",
                "new_release": "Is dit een nieuwe release?",
                "original_release_date": "Oorspronkelijke releasedatum",
                "official_release_date": "Officiële releasedatum",
                "backcatalog": "Backcatalogus",
                "assisted_dates": "Geassisteerde Data",
                "exclusive_store_release_date": "Exclusieve winkel releasedatum",
                "additional_metadata": "Aanvullende Metadata",
                "release_description": "Releasebeschrijving",
                "release_language": "Releasenaam Taal",
                "auto_detect_language": "Automatisch detecteren (Taal)",
                "ean": "EAN / UPC",
                "territories": "Territoria",
                "countries": "Landen",
                "youtube_declaration_header": "YOUTUBE CONTENT ID VERKLARING",
                "youtube_declaration_intro": "Om in te schrijven voor YouTube Content ID voor deze release, moet u ervoor zorgen dat u aan ALLE volgende vereisten voldoet:",
                "youtube_declaration_certify": "Ik, <strong>{{firstName}} {{lastName}}</strong>, onder straf van meineed, verklaar hierbij dat de bovenstaande informatie waar en correct is.",
                "youtube_declaration_point1": "Ik heb voldoende rechten op het materiaal.",
                "youtube_declaration_point2": "Alle referentie-inhoud is voldoende onderscheidend.",
                "youtube_declaration_point3": "Ik heb individuele referenties voor elk stuk intellectueel eigendom.",
                "youtube_declaration_point4": "De geleverde inhoud is <strong>niet</strong> een van de volgende: publiek domein, niet-exclusief gelicentieerde inhoud, clips van andere bronnen gebruikt onder fair use-principes, videogamebeelden (door andere dan de uitgever van het spel), karaoke-opnamen, remaster zonder toestemming, sound-alike opnamen, gedubde inhoud, versnellen/vertragen, geluidseffecten, soundbeds, continue DJ-mixen, mashups, aftellijsten of andere verboden of niet in aanmerking komende inhoud genoemd in de YouTube's Content ID Richtlijnen hieronder.",
                "youtube_declaration_account": "Ik begrijp dat mijn account kan worden gedeactiveerd en beëindigd in geval van overtredingen. Bovendien begrijp ik volledig dat ik aansprakelijk kan zijn voor eventuele kosten, schade, juridische kosten of andere kosten die kunnen oplopen.",
                "youtube_declaration_guidelines": "Volgens <1><strong>YouTube's Content ID Richtlijnen</strong></1> is de inhoud die via deze release wordt ingediend volledig in aanmerking voor YouTube Content ID.",
                "youtube_content_id_eligible": "Ik bevestig dat mijn inhoud in aanmerking komt voor <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mijn inhoud komt niet in aanmerking voor <strong>Youtube Content ID</strong>",
                "immersive_audio": "Deze Release heeft Immersive Audio"
            },
            "placeholder": {
                "version": "Laat leeg als u het niet zeker weet of als dit een reguliere release is",
                "select_date": "Selecteer datum...",
                "copyright": "Meestal uw labelnaam",
                "copyright_publisher": "Meestal uw labelnaam",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "label": "Selecteer Label...",
                "subuser": "Selecteer Subgebruiker...",
                "genre": "Selecteer Genre...",
                "subgenre": "Selecteer Subgenre...",
                "ean": "Laat leeg als u het niet zeker weet!",
                "release_description": "Enkele woorden over uw release. Geen links en e-mailadressen alstublieft. Maximaal 600 tekens"
            },
            "help_text": {
                "name": "Gebruik alstublieft geen toevoegingen aan de releasenaam zoals LP en EP.",
                "version": "Sommige releases worden in meer dan één versie uitgebracht, als dat zo is, voer dan de versienaam in. Als uw release een originele/standaard release is, negeer dit veld dan.",
                "subuser": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen voor een van uw Subgebruikers, laat anders niet geselecteerd.",
                "label": "Opmerking: Selecteer uw Label <strong>{{labelName}}</strong> uit de dropdown als het al in het systeem bestaat, anders maakt u uw Label <strong>{{labelName}}</strong> door te klikken op <5>hier</5>, zodra het is aangemaakt, kunt u het selecteren uit de dropdown.",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "artwork": "Upload JPG-formaten, resolutie alleen 3000x3000 px, @ 72 dpi",
                "original_release_date": "Oorspronkelijke releasedatum voor alle winkels wereldwijd.",
                "official_release_date": "Officiële releasedatum voor alle winkels wereldwijd.",
                "release_language": "In welke taal is de releasenaam geschreven? Controleer het dubbel als u het niet zeker weet. Als deze invoer onjuist is, zullen sommige winkels zoals iTunes en Apple Music de release afwijzen.",
                "ean": "De Universele Productcode of Europees Artikelnummer voor de release. Geldige codes zijn 13 cijfers. Als u er geen heeft, zullen wij er een voor u genereren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nee",
                "no_exclusive": "Geen exclusief",
                "beatport_2weeks": "Beatport 2 weken",
                "beatport_4weeks": "Beatport 4 weken",
                "preorder_1week": "Pre-order 1 week",
                "preorder_2weeks": "Pre-order 2 weken",
                "traxsource_2weeks": "Traxsource 2 weken",
                "select": "Selecteer...",
                "worldwide": "Wereldwijd",
                "only_selected": "Alleen geselecteerde landen",
                "all_except_selected": "Alle behalve geselecteerde landen"
            },
            "message": {
                "track_name_required": "Typ alstublieft de tracknaam",
                "mix_name_required": "Typ alstublieft de mixnaam",
                "mix_name_invalid": "De mixnaam kan alleen bestaan uit alfabetische, nummer, spatie en underscore",
                "artist_required": "Selecteer alstublieft artiest",
                "artist_type_required": "Selecteer alstublieft artiesttype",
                "catalog_duplicate": "Catalogusnummer '{{number}}' is al gebruikt. Voer een andere in.",
                "artist_added": "Nieuwe Artiest is toegevoegd!",
                "track_limit": "Uw huidige tracklimiet is {{trackLimit}} track(s). Om meer tracks te uploaden, upgrade alstublieft uw account of neem contact op met ons ondersteuningsteam.",
                "select_day": "Selecteer alstublieft een dag.",
                "form_error": "Formulier kan niet worden ingediend! Vul alle velden in en controleer op fouten!",
                "ean_invalid": "De waarde is geen geldige EAN. Als u een nieuwe release invoert, laat dit veld dan leeg en wij zullen een EAN voor u genereren. Als u een backcatalogus uploadt en de EAN is niet geldig, neem dan contact met ons op.",
                "ean_length": "Het EAN-nummer moet gelijk zijn aan 13 tekens",
                "artwork_invalid": "Dit bestand is ongeldig, zorg ervoor dat de afbeelding een .jpg-extensie heeft, RGB-kleuren, 3000 X 3000 afmetingen en tot 4MB.",
                "track_invalid": "Dit bestand is ongeldig, zorg ervoor dat u uw bestand correct codeert in 16 bit, 44.1 Khz."
            },
            "button": {
                "reset": "Resetten",
                "save_only": "Alleen opslaan",
                "save_and_continue": "Opslaan en doorgaan"
            },
            "modal": {
                "assisted_days": {
                    "header": "Weet u zeker dat u de beste praktijken voor releasedata wilt negeren?",
                    "body": "Let op, door deze optie te selecteren, kan uw releasedatum mogelijk niet door winkels worden geaccepteerd of op de geselecteerde datum worden geïmporteerd en gepubliceerd. Bovendien vermindert u sterk de marketingmogelijkheden.",
                    "button": {
                        "cancel": "Annuleren",
                        "confirm": "Bevestigen"
                    }
                },
                "release_created": {
                    "header": "Release aangemaakt!",
                    "body": "Uw release is succesvol aangemaakt!",
                    "button": {
                        "close": "Sluiten"
                    }
                },
                "release_transfer_declaration": {
                    "header": "Verklaring Release Overdracht",
                    "body": "Ik heb alle benodigde informatie voor deze release gecontroleerd en voltooid en het is nu klaar voor UPLOAD.",
                    "button": {
                        "cancel": "Annuleren",
                        "confirm": "Bevestigen"
                    }
                }
            }
        }
    },
    "viewDetails": {
        "title": "Bekijk Release",
        "form": {
            "label": {
                "required": "Vereist",
                "name": "Releasenaam",
                "version": "Releaseversie",
                "subuser": "Subgebruiker",
                "label": "Label",
                "copyright": "Copyright ©",
                "copyright_year": "Copyright © Jaar",
                "copyright_publisher": "Copyright ℗",
                "copyright_publisher_year": "Copyright ℗ Jaar",
                "genre": "Genre",
                "subgenre": "Subgenre",
                "catalog_number": "Catalogusnummer",
                "artwork": "Omslag",
                "artwork_alt": "Uw omslag",
                "new_release": "Is dit een nieuwe release?",
                "original_release_date": "Oorspronkelijke releasedatum",
                "official_release_date": "Officiële releasedatum",
                "backcatalog": "Backcatalogus",
                "assisted_dates": "Geassisteerde Data",
                "exclusive_store_release_date": "Exclusieve winkel releasedatum",
                "additional_metadata": "Aanvullende Metadata",
                "release_description": "Releasebeschrijving",
                "release_language": "Releasenaam Taal",
                "auto_detect_language": "Automatisch detecteren (Taal)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatisch genereren (ean)",
                "territories": "Territoria",
                "countries": "Landen",
                "youtube_declaration_header": "YOUTUBE CONTENT ID VERKLARING",
                "youtube_declaration_intro": "Om in te schrijven voor YouTube Content ID voor deze release, moet u ervoor zorgen dat u aan ALLE volgende vereisten voldoet:",
                "youtube_declaration_certify": "Ik, <strong>{{firstName}} {{lastName}}</strong>, onder straf van meineed, verklaar hierbij dat de bovenstaande informatie waar en correct is.",
                "youtube_declaration_point1": "Ik heb voldoende rechten op het materiaal.",
                "youtube_declaration_point2": "Alle referentie-inhoud is voldoende onderscheidend.",
                "youtube_declaration_point3": "Ik heb individuele referenties voor elk stuk intellectueel eigendom.",
                "youtube_declaration_point4": "De geleverde inhoud is <strong>niet</strong> een van de volgende: publiek domein, niet-exclusief gelicentieerde inhoud, clips van andere bronnen gebruikt onder fair use-principes, videogamebeelden (door andere dan de uitgever van het spel), karaoke-opnamen, remaster zonder toestemming, sound-alike opnamen, gedubde inhoud, versnellen/vertragen, geluidseffecten, soundbeds, continue DJ-mixen, mashups, aftellijsten of andere verboden of niet in aanmerking komende inhoud genoemd in de YouTube's Content ID Richtlijnen hieronder.",
                "youtube_declaration_account": "Ik begrijp dat mijn account kan worden gedeactiveerd en beëindigd in geval van overtredingen. Bovendien begrijp ik volledig dat ik aansprakelijk kan zijn voor eventuele kosten, schade, juridische kosten of andere kosten die kunnen oplopen.",
                "youtube_declaration_guidelines": "Volgens <1><strong>YouTube's Content ID Richtlijnen</strong></1> is de inhoud die via deze release wordt ingediend volledig in aanmerking voor YouTube Content ID.",
                "youtube_content_id_eligible": "Ik bevestig dat mijn inhoud in aanmerking komt voor <strong>Youtube Content ID</strong>",
                "youtube_content_id_not_eligible": "Mijn inhoud komt niet in aanmerking voor <strong>Youtube Content ID</strong>",
                "immersive_audio": "Deze Release heeft Immersive Audio"
            },
            "placeholder": {
                "version": "Laat leeg als u het niet zeker weet of als dit een reguliere release is",
                "select_date": "Selecteer datum...",
                "copyright": "Meestal uw labelnaam",
                "copyright_publisher": "Meestal uw labelnaam",
                "copyright_year": "JJJJ",
                "copyright_year_publisher": "JJJJ",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "label": "Selecteer Label...",
                "subuser": "Selecteer Subgebruiker...",
                "artist": "Selecteer Artiest...",
                "genre": "Selecteer Genre...",
                "subgenre": "Selecteer Subgenre...",
                "ean": "Laat leeg als u het niet zeker weet!",
                "release_description": "Enkele woorden over uw release. Geen links en e-mailadressen alstublieft. Maximaal 600 tekens"
            },
            "help_text": {
                "name": "Gebruik alstublieft geen toevoegingen aan de releasenaam zoals LP en EP.",
                "version": "Sommige releases worden in meer dan één versie uitgebracht, als dat zo is, voer dan de versienaam in. Als uw release een originele/standaard release is, negeer dit veld dan.",
                "subuser": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen voor een van uw Subgebruikers, laat anders niet geselecteerd.",
                "catalog_number": "Voer uw catalogusnummer in. Meestal voegen labels een afkorting van de labelnaam en een nummer toe. Bijv. {{prefix}}001, {{prefix}}002...",
                "artwork": "Upload JPG-formaten, resolutie alleen 3000x3000 px, @ 72 dpi",
                "original_release_date": "Oorspronkelijke releasedatum voor alle winkels wereldwijd.",
                "official_release_date": "Officiële releasedatum voor alle winkels wereldwijd.",
                "release_language": "In welke taal is de releasenaam geschreven? Controleer het dubbel als u het niet zeker weet. Als deze invoer onjuist is, zullen sommige winkels zoals iTunes en Apple Music de release afwijzen.",
                "ean": "De Universele Productcode of Europees Artikelnummer voor de release. Geldige codes zijn 13 cijfers. Als u er geen heeft, zullen wij er een voor u genereren."
            },
            "option": {
                "yes": "Ja",
                "no": "Nee",
                "no_exclusive": "Geen exclusief",
                "beatport_2weeks": "Beatport 2 weken",
                "beatport_4weeks": "Beatport 4 weken",
                "preorder_1week": "Pre-order 1 week",
                "preorder_2weeks": "Pre-order 2 weken",
                "traxsource_2weeks": "Traxsource 2 weken",
                "select": "Selecteer...",
                "worldwide": "Wereldwijd",
                "only_selected": "Alleen geselecteerde landen",
                "all_except_selected": "Alle behalve geselecteerde landen"
            },
            "message": {
                "track_name_required": "Typ alstublieft de tracknaam",
                "mix_name_required": "Typ alstublieft de mixnaam",
                "mix_name_invalid": "De mixnaam kan alleen bestaan uit alfabetische, nummer, spatie en underscore",
                "artist_required": "Selecteer alstublieft artiest",
                "artist_type_required": "Selecteer alstublieft artiesttype",
                "catalog_duplicate": "Catalogusnummer '{{number}}' is al gebruikt. Voer een andere in.",
                "artist_added": "Nieuwe Artiest is toegevoegd!",
                "track_limit": "Uw huidige tracklimiet is {{trackLimit}} track(s). Om meer tracks te uploaden, upgrade alstublieft uw account of neem contact op met ons ondersteuningsteam.",
                "select_day": "Selecteer alstublieft een dag.",
                "form_error": "Formulier kan niet worden ingediend! Vul alle velden in en controleer op fouten!",
                "ean_invalid": "De waarde is geen geldige EAN. Als u een nieuwe release invoert, laat dit veld dan leeg en wij zullen een EAN voor u genereren. Als u een backcatalogus uploadt en de EAN is niet geldig, neem dan contact met ons op.",
                "ean_length": "Het EAN-nummer moet gelijk zijn aan 13 tekens",
                "artwork_invalid": "Dit bestand is ongeldig, zorg ervoor dat de afbeelding een .jpg-extensie heeft, RGB-kleuren, 3000 X 3000 afmetingen en tot 4MB.",
                "track_invalid": "Dit bestand is ongeldig, zorg ervoor dat u uw bestand correct codeert in 16 bit, 44.1 Khz."
            },
            "button": {
                "submit": "Formulier Indienen"
            },
            "modal": {
                "assisted_days": {
                    "header": "Weet u zeker dat u de beste praktijken voor releasedata wilt negeren?",
                    "body": "Let op, door deze optie te selecteren, kan uw releasedatum mogelijk niet door winkels worden geaccepteerd of op de geselecteerde datum worden geïmporteerd en gepubliceerd. Bovendien vermindert u sterk de marketingmogelijkheden.",
                    "button": {
                        "cancel": "Annuleren",
                        "confirm": "Bevestigen"
                    }
                },
                "release_updated": {
                    "header": "Release bijgewerkt!",
                    "body": "Uw release is succesvol bijgewerkt!",
                    "button": {
                        "close": "Sluiten"
                    }
                }
            }
        }
    },
    "artists_row": {
        "artistType": {
            "main": "Hoofdartiest",
            "featuring": "Featuring Artiest",
            "remixer": "Remixer"
        },
        "placeholder": {
            "selectArtist": "Selecteer Artiest..."
        },
        "button": {
            "remove": "Verwijderen",
            "addAnother": "Nog een toevoegen",
            "createNew": "Nieuwe maken?"
        },
        "modal": {
            "header": "Weet u zeker dat u deze artiest als Featuring Artiest wilt toewijzen?",
            "body": "Verwar Featuring Artiest niet met een Remixer. Featuring Artiest moet alleen worden toegevoegd als u zeker weet dat deze artiest niet de Hoofdartiest of Remixer is.",
            "cancel": "Annuleren",
            "confirm": "Bevestigen"
        },
        "label": {
            "order": "Volgorde",
            "artistName": "Artiestnaam",
            "artistType": "Artiesttype",
            "artists": "Artiesten",
            "required": "Vereist"
        },
        "help_text": {
            "artists": "Als de release is geschreven door meer dan <strong>4 Hoofdartiesten</strong> gebruik dan <strong>Verschillende Artiesten</strong>. Trackartiesten, remixers en bijdragers moeten worden toegevoegd in de Track Bewerken stap."
        }
    },
    "tracks_row": {
        "label": {
            "tracks": "Tracks",
            "order": "Volgorde",
            "trackName": "Tracknaam",
            "mixName": "Mixnaam",
            "file": "Bestand",
            "albumOnly": "Alleen Album",
            "required": "Vereist",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Nog een toevoegen",
            "remove": "Verwijderen?",
            "onlyAlbum": "Alleen Album",
            "mixTypes": {
                "originalMix": "Originele Mix",
                "remixOrMix": "Dit is een Remix of Mix"
            }
        },
        "button": {
            "remove": "Verwijderen",
            "addAnother": "Nog een toevoegen"
        },
        "validation": {
            "trackName": "Typ alstublieft de tracknaam",
            "mixName": "Typ alstublieft de mixnaam",
            "mixNameRegex": "De mixnaam kan alleen bestaan uit alfabetische, nummer, spatie en underscore",
            "trackFile": "Selecteer alstublieft trackbestand",
            "trackFileDolby": "Selecteer alstublieft track dolby atmos bestand",
            "trackFileDuration": "De duur van Stereo en Dolby trackbestanden moet overeenkomen",
            "swapTrackAudioTokenRequiredTooltip": "Je huidige tokenbalans is onvoldoende. Er is minimaal 1 token vereist om track-audio te vervangen."
        }
    },
    "transfer_artists_row": {
        "label": {
            "artists": "Artiesten",
            "order": "Volgorde",
            "artistName": "Artiestnaam",
            "artistType": "Artiesttype",
            "required": "Vereist"
        },
        "placeholder": {
            "selectArtist": "Selecteer Artiest..."
        },
        "help_text": {
            "artists": "Als de release is geschreven door meer dan <strong>4 Hoofdartiesten</strong> gebruik dan <strong>Verschillende Artiesten</strong>. Trackartiesten, remixers en bijdragers moeten worden toegevoegd in de Track Bewerken stap."
        },
        "option": {
            "artistType": {
                "main": "Hoofdartiest",
                "featuring": "Featuring Artiest",
                "remixer": "Remixer"
            }
        },
        "button": {
            "remove": "Verwijderen",
            "addAnother": "Nog een toevoegen",
            "createNew": "Nieuwe maken?"
        },
        "message": {
            "errorArtistRequired": "Selecteer alstublieft artiest",
            "errorArtistTypeRequired": "Selecteer alstublieft type artiest"
        },
        "modal": {
            "header": "Weet u zeker dat u deze artiest als Featuring Artiest wilt toewijzen?",
            "body": "Verwar Featuring Artiest niet met een Remixer. Featuring Artiest moet alleen worden toegevoegd als u zeker weet dat deze artiest niet de Hoofdartiest of Remixer is.",
            "button": {
                "cancel": "Annuleren",
                "confirm": "Bevestigen"
            }
        }
    },
    "store_picker": {
        "label": {
            "stores": "Winkels"
        },
        "placeholder": {
            "search": "Zoek winkel..."
        },
        "section": {
            "mandatory": "Verplicht",
            "optional": "Optioneel",
            "optional_locked": "Optioneel Extra Winkels",
            "summary": {
                "read_only": "{{title}} ({{count}} totaal)",
                "editable": "{{title}} ({{total}} totaal, {{selected}} geselecteerd)"
            }
        },
        "message": {
            "no_stores": "Geen winkels gevonden.",
            "availability": "Beatport is alleen beschikbaar voor Dance-releases met Beatport-goedgekeurde labels. Traxsource is alleen beschikbaar voor Dance-releases met Traxsource-goedgekeurde labels.",
            "youtube_declaration": "Onderteken eerst de YouTube Content ID-verklaring.",
            "youtube_ineligible": "Deze winkel komt niet in aanmerking omdat u heeft aangegeven dat u niet over de eigendomsrechten beschikt. Als dit onjuist is opgegeven, kunt u aansprakelijk zijn voor een juridisch geschil.",
            "youtube_content_id": "Deze winkel is niet van toepassing op releases die in aanmerking komen voor YouTube Content ID, omdat deze zowel aan YouTube Content ID als aan YouTube Premium wordt geleverd.",
            "beatport": "Beatport kan alleen worden geselecteerd wanneer het genre Dance is en het label is goedgekeurd voor Beatport.",
            "traxsource": "Traxsource kan alleen worden geselecteerd wanneer het genre Dance is en het label is goedgekeurd voor Traxsource.",
            "juno": "JunoDownload kan alleen worden geselecteerd wanneer het genre Dance is.",
            "contact_support": "Neem contact op met ons supportteam om deze winkels te ontgrendelen.",
            "optional_additional_none_selected": "Je hebt geen Optionele Extra Winkels geselecteerd. Deze kunnen je bereik vergroten. Weet je zeker dat je ze wilt overslaan?",
            "optional_paid_insufficient_tokens": "Onvoldoende tokenbalans. Er is minimaal 1 token vereist om Optionele Extra Winkels te selecteren.",
            "optional_paid_insufficient_tokens_with_link": "Je huidige tokenbalans is onvoldoende. Er is minimaal 1 token vereist om Optionele Extra Winkels te selecteren. <2>Bestel tokens</2> om door te gaan."
        }
    },
    "transfer_tracks_row": {
        "label": {
            "tracks": "Tracks",
            "order": "Volgorde",
            "trackName": "Tracknaam",
            "mixName": "Mixnaam",
            "file": "Bestand",
            "albumOnly": "Alleen Album",
            "required": "Vereist",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Nog een toevoegen",
            "remove": "Verwijderen?",
            "onlyAlbum": "Alleen Album",
            "mixTypes": {
                "originalMix": "Originele Mix",
                "remixOrMix": "Dit is een Remix of Mix"
            }
        },
        "button": {
            "remove": "Verwijderen",
            "addAnother": "Nog een toevoegen"
        },
        "validation": {
            "trackName": "Typ alstublieft de tracknaam",
            "mixName": "Typ alstublieft de mixnaam",
            "mixNameRegex": "De mixnaam kan alleen bestaan uit alfabetische, nummer, spatie en underscore",
            "trackFile": "Selecteer alstublieft trackbestand",
            "trackFileDolby": "Selecteer alstublieft track dolby atmos bestand",
            "trackFileDuration": "De duur van Stereo en Dolby trackbestanden moet overeenkomen"
        }
    }
};

export default releasesNL;